import { MigrateStakeholdersComponent } from './../../migrate-stakeholders/migrate-stakeholders.component';

export class ListOptionsService {

  public static connectionOptions = ['Exchange'];

}

export const menus = {
  Environment: {
    path: 'Environment',
    title: 'MENU_CATEGORY.ENVIRONMENT'
  },
  GlobalProxy: {
    path: 'GlobalProxy',
    title: 'MENU.GLOBALPROXY'
  },
  DeploymentPackage: {
    path: 'Deployment',
    title: 'MENU.DEPLOYMENTPACKAGE'
  },
  SyncData: {
    path: 'SyncData',
    title: 'MENU.SYNCDATA'
  },
  SyncFilesExport: {
    path: 'SyncFilesExport',
    title: 'MENU.SYNCFILESEXPORT'
  },
  SyncFilesImport: {
    path: 'SyncFilesImport',
    title: 'MENU.SYNCFILESIMPORT'
  },
  MigrateStakeholders: {
    path: 'MigrateStakeholders',
    title: 'MENU.MIGRATESTAKEHOLDERS'
  },
  MaintenanceWindow: {
    path: 'Maintenance',
    title: 'MENU.MAINTENANCEWINDOW'
  },
  Sequences: {
    path: 'Sequences',
    title: 'MENU.SEQUENCES'
  },
  CustomCertificate: {
    path: 'CustomCertificate',
    title: 'MENU.CUSTOMCERTIFICATE'
  },
  Security: {
    path: 'Security',
    title: 'MENU.SECURITY'
  },
  Ldap: {
    path: 'LDAP',
    title: 'MENU.LDAP'
  },
  Interfaces: {
    path: 'Interfaces',
    title: 'MENU.CONNECT_INTERFACES_SETTINGS'
  },
  Connectors: {
    path: 'Connectors',
    title: 'MENU.CONNECT_CONNECTORS_SETTINGS'
  },
  Triggers: {
    path: 'Triggers',
    title: 'MENU.CONNECT_TRIGGERS_SETTINGS'
  },
  Tracing: {
    path: 'Tracing',
    title: 'MENU.TRACING'
  },
  TracingManagement: {
    path: 'TracingManagement',
    title: 'MENU.TRACINGMANAGEMENT'
  },
  EventTracing: {
    path: 'EventsLog',
    title: 'MENU.EVENTTRACING'
  },
  AuditLog: {
    path: 'AuditLog',
    title: 'MENU.AUDITLOG'
  },
  BPUMonitoring: {
    path: 'BpmConsume',
    title: 'MENU.BPUMONITORING'
  },
  ECM: {
    path: 'ECM',
    title: 'MENU.CONNECT_ECM_SETTINGS'
  },
  Providers: {
    path: 'Providers',
    title: 'MENU.PROVIDERS_SETTINGS'
  },
  UserJobs: {
    path: 'UserJobs',
    title: 'MENU.USERJOBS'
  },
  Waits: {
    path: 'Waits',
    title: 'MENU.WAITS'
  },
  Alerts: {
    path: 'Alerts',
    title: 'MENU.ALERTS'
  },
  DeleteCases: {
    path: 'delete-cases',
    title: 'MENU.DELETECASES'
  },
  TimeZone: {
    path: 'timezone',
    title: 'MENU.TIMEZONE'
  },
  ChangeWebAdminPassword: {
    path: 'change-password-administrator',
    title: 'CHANGE_PASSWORD_ADMIN.MAIN_TITLE'
  },
  UserGroups: {
    path: 'UserGroups',
    title: 'MENU.USERGROUPS'
  },
  WorkingTimeSchema: {
    path: 'working-time-schema',
    title: 'MENU.WORKINGTIMESCHEMA'
  },
  ExcelConnector:
  {
    path: 'excelconnector',
    title: 'MENU.EXCELCONNECTOR'
  },
  SAPCPConnector: {
    path: "sapcpconnector",
    title: "MENU.SAPCPCONNECTOR"
  },
  FormsRecognizer: {
    path: 'formsrecognizer',
    title: 'MENU.FORMSRECOGNIZER'
  },
  UiPath:
  {
    path: 'uipath',
    title: 'MENU.UIPATH'
  },
  BluePrism:
  {
    path: 'blue-prism',
    title: 'MENU.BLUEPRISM'
  },
  AutomationAnywhere:
  {
    path: 'automation-anywhere',
    title: 'MENU.AUTOMATIONANYWHERE'
  },
  PowerBI: {
    path: 'PowerBI',
    title: 'MENU.POWERBI'
  },
  Tableau: {
    path: 'Tableau',
    title: 'MENU.TABLEAU'
  },
  BaseKnowledgeCatalog: {
    path: 'BaseKnowledgeCatalog',
    title: 'MENU.BASEKNOWLEDGECATALOG'
  },
};


export const DELAY_FILTER_USERS = 600;
export const DELAY_SET_CURRENT_GROUP = 600;
